export enum ContentFilter {
  Any = 0,
  ServicesOnly = 1,
  ClassesOnly = 2,
  ServicesOrClasses = 3,
  PickUp = 4
}

interface StoreHour {
  wday: number;
  open: string;
  close: string;
  comments: string;
}

interface DepartmentType {
  id: number;
  name: string;
  description?: string;
}

export interface LocationInterface {
  id: number;
  name: string;
  full_name: string;
  recent: number;
  addr1: string;
  addr2: string | null;
  city: string;
  province: string;
  postal: string;
  country: string;
  phone: string;
  email: string;
  latitude: number | null;
  longitude: number | null;
  website_url: string;
  fav: number;
  is_primary: number;
  public_hours_holidays: string | null;
  public_hours_text: string | null;
  sv_cnt: string;
  cl_cnt: string;
  public_hours_week_start: number;
  image_url: string | null;
  store_hours: StoreHour[];
  departments: DepartmentType[];
}

export interface GroupedLocations {
  [city: string]: LocationInterface[];
}

export interface CoordinatesInterface {
  latitude: number;
  longitude: number;
}

export enum LocationInfoType {
  NO_FAVORITE_LOCATION,
  SERVICE_NOT_ACTIVATED,
  NO_NEAREST_LOCATION
}

export enum LocationFlowType {
  BOOK,
  PACKAGES,
  PRODUCT,
  PACKAGES_PROMO,
  GIFT_CARDS,
  BASKET,
  MEMBERSHIPS
}

export enum LocationPickType {
  LIST,
  FAVORITES,
  NEAR_ME
}
